"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedQuadTree = void 0;
const rc_js_util_1 = require("rc-js-util");
const range2d_shared_object_1 = require("./range2d-shared-object");
const quad_element_shared_object_1 = require("./quad-element-shared-object");
/**
 * @public
 * {@inheritDoc ISharedQuadTree}
 */
class SharedQuadTree {
    constructor(wrapper, maxDepth, maxElementsPerNode, maximumResultCount) {
        this.wrapper = wrapper;
        this.maximumResultCount = maximumResultCount;
        this.onMemoryResize = () => {
            this.results = this.getResultArray();
        };
        this.isInitialized = false;
        const treePointer = wrapper.instance._f32QuadTree_createTree(maxDepth, maxElementsPerNode);
        this.sharedObject = new rc_js_util_1.ReferenceCountedPtr(false, treePointer);
        this.sharedObject.registerOnFreeListener(this.wrapper.memoryResize.addTemporaryListener(this));
        this.sharedObject.registerOnFreeListener(() => this.wrapper.instance._f32QuadTree_delete(this.sharedObject.getPtr()));
        DEBUG_MODE && rc_js_util_1._Debug.runBlock(() => {
            const protectedView = new rc_js_util_1.DebugProtectedView(["BYTES_PER_ELEMENT"], "Shared quad tree - memory resize danger, refresh instance with getResults");
            rc_js_util_1.DebugSharedObjectChecks.registerWithCleanup(this, protectedView, "shared array");
        });
        this.sharedRange2d = range2d_shared_object_1.Range2dSharedObject.createOneF32(wrapper);
        this.sharedObject.takeOwnership(this.sharedRange2d.sharedObject);
        this.sharedQuadElement = new quad_element_shared_object_1.QuadElementSharedObject(wrapper);
        this.sharedObject.takeOwnership(this.sharedQuadElement.sharedObject);
        this.maximumResultCount = SharedQuadTree.getResultCount(maximumResultCount);
        this.resultAddress = this.wrapper.instance._quadTree_getResultAddress();
        this.results = this.getResultArray();
    }
    static createOneF32(wrapper, maxDepth, maxElementsPerNode, maximumResultCount) {
        return new SharedQuadTree(wrapper, maxDepth, maxElementsPerNode, maximumResultCount);
    }
    getResults() {
        if (DEBUG_MODE) {
            return RcJsUtilDebug.protectedViews
                .getValue(this)
                .createProtectedView(this.results);
        }
        else {
            return this.results;
        }
    }
    addBoundingBox(aabb, entityId, dataId, filterMask) {
        this.sharedQuadElement.update(entityId, dataId, filterMask);
        this.sharedRange2d.update(aabb);
        this.wrapper.instance._f32QuadTree_insertRange(this.sharedObject.getPtr(), this.sharedRange2d.sharedObject.getPtr(), this.sharedQuadElement.sharedObject.getPtr());
    }
    setTopLevel(range2d) {
        this.sharedRange2d.update(range2d);
        this.wrapper.instance._f32QuadTree_setTopLevel(this.sharedObject.getPtr(), this.sharedRange2d.sharedObject.getPtr());
        this.isInitialized = true;
    }
    setOptions(maxDepth, maxElementsPerNode) {
        this.wrapper.instance._quadTree_setOptions(this.sharedObject.getPtr(), maxDepth, maxElementsPerNode);
    }
    queryPoint(point, filterMask) {
        if (!this.isInitialized) {
            return 0;
        }
        return this.wrapper.instance._f32QuadTree_queryPoint(this.sharedObject.getPtr(), point.getX(), point.getY(), filterMask);
    }
    getQuadElementCount() {
        return this.wrapper.instance._quadTree_getQuadElementCount(this.sharedObject.getPtr());
    }
    getResultArray() {
        return new Uint32Array(this.wrapper.memory.buffer, this.resultAddress, this.maximumResultCount);
    }
    static getResultCount(maximumResultCount) {
        const theoreticalMax = 4096 * 4 * quad_element_shared_object_1.QuadElementSharedObject.byteSize;
        return rc_js_util_1._Math.min(maximumResultCount !== null && maximumResultCount !== void 0 ? maximumResultCount : theoreticalMax, theoreticalMax);
    }
}
exports.SharedQuadTree = SharedQuadTree;
//# sourceMappingURL=shared-quad-tree.js.map